import angular from 'angular';
import orgDataService from '../data/org.data.service';
import ISharedModelService from './ISharedModel.service';


let _orgDataService;

class orgSharedModelService extends ISharedModelService {
  constructor(
    orgDataService // eslint-disable-line no-shadow
  ) {
    super('org');
    _orgDataService = orgDataService;

    console.log('app.services.orgSharedModelService created');
  }

  getCustomer(customerId, forceRefresh) {
    return this.getCachedCustomer(customerId, forceRefresh)
      .then(r => r.customer);
  }

  getCachedCustomer(customerId, forceRefresh = false) {
    if (forceRefresh || !this.cache.org.customer) {
      this.cache.org.customer = _orgDataService.getCustomer(customerId)
        .then((response) => {
          const customer = response.data;

          return {
            customer,
          };
        });
    }
    return this.cache.org.customer;
  }
}

orgSharedModelService.$inject = [
  'orgDataService'
];

export default angular.module('app.services.orgSharedModelService', [
  orgDataService
])
  .service('orgSharedModelService', orgSharedModelService)
  .name;
